// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KFpN3","colMin":"styles_colMin__1Y5E3"};